import { render, staticRenderFns } from "./PasswordBox.vue?vue&type=template&id=8130cbc6&"
import script from "./PasswordBox.vue?vue&type=script&lang=js&"
export * from "./PasswordBox.vue?vue&type=script&lang=js&"
import style0 from "./PasswordBox.vue?vue&type=style&index=0&id=8130cbc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports